import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es';
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat, split } from 'apollo-link';
import store from './store/store'
import SecureLS from 'secure-ls'
import Cookies from 'js-cookie'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';
import { myUrl } from './Settings';
import 'default-passive-events'
import IdleVue from 'idle-vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

// import sidebarLinks from './sidebarLinks2'
const sidebarLinks = []
// import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
import { networkInterfaces } from 'os'

// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate, Validator)
Vue.use(VueApollo)

Validator.localize("es", es);
locale.use(lang)


// Sentry.init({
//   dsn: 'https://513015e3de8742d2954f020a73340a62@o374617.ingest.sentry.io/5248591',
//   integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
//   environment: process.env.VUE_APP_MODE,
//   release: process.env.VUE_APP_SENTRY_RELEASE
// });
// Sentry.configureScope(function(scope) {
//   scope.setTag("Analyst", store.getters.getUserFullName);
// });
//Asignación del CSRF del backend
// Vue.prototype.$window = window;

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})
const loginRoutes = ['/login','/password_change','/reset_password','/reset']
// Global navigation guards
  router.beforeEach((to, from, next) => {
    var ls = new SecureLS({encodingType: 'aes'});
    // Manejo de errorres para ver si las variable almacenada de manera cifrada están errónea o han sido modificadas
    try {
        Vue.prototype.$loggingIn = ls.get('loggingIn');
        Vue.prototype.$permissions = ls.get('permissions');
        Vue.prototype.$accessToken = ls.get('accessToken');
        Vue.prototype.$refreshToken = ls.get('refreshToken');
        Vue.prototype.$tokenExpireDate = ls.get('tokenExpireDate');
        if(Vue.prototype.$loggingIn.data){
          if(!Vue.prototype.$permissions || !Vue.prototype.$accessToken || !Vue.prototype.$refreshToken || !Vue.prototype.$tokenExpireDate){
            router.go('/login')
          }
        }
    } catch(e) {
        router.go('/login')
    }
    if(to.path.includes('/reset_password'))
    {
      if(!Vue.prototype.$loggingIn.data) next()
      else next('/login')
    }
    else
    {
      if(loginRoutes.indexOf(to.path)<= -1)
      {
        if(!Vue.prototype.$loggingIn.data) next('/login')
        else next()
      }
      else if(loginRoutes.indexOf(to.path) > -1)
      {
        if(Vue.prototype.$loggingIn.data) next('/')
        else next()
      }
      else next()
    }
    
  
  
})
var ls = new SecureLS({encodingType: 'aes'});
Vue.prototype.$token = ls.get('accessToken');
const authMiddleware = new ApolloLink((operation, forward) => {
  var ls = new SecureLS({encodingType: 'aes'});
  Vue.prototype.$token = ls.get('accessToken');
  if (Vue.prototype.$token) {
    operation.setContext({
      headers: {
        authorization: 'jwt '+Vue.prototype.$token.data || null,
        'X-CSRFToken': Cookies.get('csrftoken'),
      }
    });
    return forward(operation);
  }
  else {
    operation.setContext({
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
      }
    });
    return forward(operation);
  }
})
const onErrorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        // console.log(message);
        if(message == "Invalid token"){
          store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }
        if(message == "El token de refresco está expirado" || message == "Refresh token is expired"){
          store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }
        if(message == "Token de refresco inválido" || message == "Invalid refresh token"){
          store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }
      })        
  }
});
  // When a 401 error occur, we log-out the user.
  // if (networkError) {
  //   switch (networkError.statusCode) {
	// 		case 500:
	// 			console.log('algo');
	// 			break
	// 		case 403:
	// 			console.log('403 algo');
	// 			break
	// 		case undefined:
	// 			//
	// 			break
	// 		default:
	// 			console.error(networkError)
	// 			break
	// 	}
  // }

//httplink
const httpLink = new HttpLink({
  uri: myUrl
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  // link: onErrorLink.concat(httpLink),
  // link: concat(onErrorLink,httpLink,authMiddleware),
  // link: concat(authMiddleware,httpLink, onErrorLink),
  link: ApolloLink.from([onErrorLink,authMiddleware,httpLink]),
  // link:  httpLink,
  cache,
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.prototype.$vuexApollo = apolloClient;

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  apolloProvider
})
